/**
 * VibeCats — Smooth Scroll (Lenis) + ScrollTrigger
 *
 * Configura o Lenis para scroll suave e integra com ScrollTrigger.
 * Atualiza o ScrollTrigger a cada frame para sincronia perfeita.
 */

const ScrollManager = (($) => {
    'use strict';

    let lenis = null;
    let rafId = null;

    /**
     * Inicializa o Lenis (smooth scroll) e conecta com ScrollTrigger.
     */

    function init() {
        if (Utils.prefersReducedMotion()) {
            ScrollTrigger.refresh();
            return;
        }

        lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            orientation: 'vertical',
            gestureOrientation: 'vertical',
            smoothWheel: false,
            wheelMultiplier: 1,
            touchMultiplier: 1.5,
        });

        lenis.on('scroll', ScrollTrigger.update);

        gsap.ticker.add((time) => {
            lenis.raf(time * 1000);
        });

        gsap.ticker.lagSmoothing(0);

        ScrollTrigger.refresh();
    }

    /**
     * Destroi a instância do Lenis.
     */
    function destroy() {
        if (rafId) cancelAnimationFrame(rafId);
        if (lenis) {
            lenis.destroy();
            lenis = null;
        }
    }

    /**
     * Faz scroll suave para um elemento específico.
     * @param {string|HTMLElement} target
     * @param {object} options
     */
    function scrollTo(target, options = {}) {
        if (!lenis) {
            // Fallback nativo
            const el = typeof target === 'string' ? document.querySelector(target) : target;
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
        }
        lenis.scrollTo(target, {
            duration: options.duration || 1.8,
            easing: options.easing || ((t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))),
            offset: options.offset || 0,
            ...options,
        });
    }

    return {
        init,
        destroy,
        scrollTo,
        get lenis() { return lenis; },
    };
})(gsap);
